import { useIntl } from 'react-intl'

import Box from 'app/components/base/Box'
import Link from 'app/components/base/Link'
import Text, { TextProps } from 'app/components/base/Text'
import { IS_NATIVE_APP, WEBSITE_URL } from 'app/utils/constants/env.constants'

const textCommonProps: TextProps = {
  variant: 'subtitle2',
  color: 'common.white'
}

const QuestionTooltipContent: RFC = () => {
  const { formatMessage } = useIntl()

  const learnMoreLink = IS_NATIVE_APP
    ? `/webview?uri=${WEBSITE_URL}/help-centre/account/how-do-i-create-an-account#Business%20Account&title=Help Centre`
    : '/help-centre/account/how-do-i-create-an-account#Business%20Account'

  return (
    <Box sx={{ maxWidth: '254px' }}>
      <Text {...textCommonProps}>
        {formatMessage({
          defaultMessage:
            "Running an auto parts business? You've arrived at the right pit stop."
        })}
      </Text>
      <Text {...textCommonProps}>
        {formatMessage({ defaultMessage: 'Choose this option if:' })}
      </Text>

      <Box sx={{ ml: 1 }}>
        <Text {...textCommonProps}>
          &#8226;{'   '}
          {formatMessage({ defaultMessage: 'You’re a business' })}
        </Text>
        <Text {...textCommonProps}>
          &#8226;{'   '}
          {formatMessage({
            defaultMessage: 'You sell a large number of goods'
          })}
        </Text>
        <Text {...textCommonProps}>
          &#8226;{'   '}
          {formatMessage({
            defaultMessage: 'You plan to turbocharge your sales'
          })}
        </Text>
      </Box>

      <Link href={learnMoreLink} target="_blank">
        <Text
          {...textCommonProps}
          fontWeight={500}
          sx={{
            ...(!IS_NATIVE_APP && { '&:hover': { color: 'secondary.dark' } })
          }}
        >
          {formatMessage({ defaultMessage: 'Learn More' })}
        </Text>
      </Link>
    </Box>
  )
}

export default QuestionTooltipContent
